import React from 'react';
import { motion } from 'framer-motion';
import '../styles/AnimatedTopSection.css';

export default function AnimatedTopSection() {
    return (
        <section id="home" >
        <header className="hero-section">
            {/* Animated background elements */}
            <div className="particles-container">
                {[...Array(15)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="particle"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                            opacity: [0, 0.6, 0],
                            y: [0, Math.random() * 100 - 50],
                            x: [0, Math.random() * 200 - 100]
                        }}
                        transition={{
                            duration: 10 + Math.random() * 10,
                            repeat: Infinity,
                            delay: Math.random() * 5,
                            ease: "linear"
                        }}
                    />
                ))}
            </div>

            {/* Glowing accent elements */}
            <motion.div
                className="glowing-accent left-accent"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 0.3, scale: 1 }}
                transition={{ duration: 1.5, delay: 0.5 }}
            />
            <motion.div
                className="glowing-accent right-accent"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 0.2, scale: 1 }}
                transition={{ duration: 1.5, delay: 0.7 }}
            />

            <div className="hero-container">
                {/* Left content */}
                <motion.div
                    className="hero-content"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2, delay: 0.2 }}
                >
                    <motion.div
                        className="badge"
                        initial={{ scale: 0, rotate: -15 }}
                        animate={{ scale: 1, rotate: 0 }}
                        transition={{ type: 'spring', stiffness: 200, damping: 15, delay: 0.4 }}
                    >
                        Premium Internet Services
                    </motion.div>

                    <motion.h1
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                        className="hero-title"
                    >
                        ԲԱՐՁՐՈՐԱԿ <span className="text-gradient">ԻՆՏԵՐՆԵՏ</span>,
                        <br />
                        ՀԵՌՈՒՍՏԱԼԻՔ ԵՒ ԹՎԱՅԻՆ <span className="text-stroke">ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ</span>
                    </motion.h1>

                    <motion.p
                        className="hero-subtitle"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.7 }}
                    >
                        Մատուցում ենք արագագույն ինտերնետ, բարձրորակ հեռուստաալիքներ և
                        թվային լուծումներ՝ մատչելի գներով
                    </motion.p>

                    <motion.div
                        className="cta-container"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.9 }}
                    >


                        <div className="trust-badge">
                            <div className="trust-stars">
                                {[...Array(5)].map((_, i) => (
                                    <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                    </svg>
                                ))}
                            </div>
                            <span>3000+ գոհ հաճախորդներ</span>
                        </div>
                    </motion.div>
                </motion.div>

                {/* Right content */}
                <motion.div
                    className="hero-media"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2, delay: 0.4 }}
                >
                    <motion.div
                        className="video-card"
                        initial={{ scale: 0.9, opacity: 0, rotateY: 15 }}
                        animate={{ scale: 1, opacity: 1, rotateY: 0 }}
                        transition={{ duration: 1, delay: 0.6 }}
                    >
                        <div className="video-inner">
                            <video autoPlay loop muted playsInline>
                                <source src="/assets/bg-animation.mp4" type="video/mp4" />
                            </video>
                            <div className="video-shine"></div>
                            <div className="video-border"></div>
                        </div>
                        <div className="video-dots">
                            {[...Array(36)].map((_, i) => (
                                <div key={i} className="video-dot"></div>
                            ))}
                        </div>
                    </motion.div>

                    <motion.div
                        className="floating-tag"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8, delay: 1.2 }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                        <span>100% Ապահով Կապ</span>
                    </motion.div>
                </motion.div>
            </div>
        </header>
        </section>
    );
}